const messages = {
  en: {
    "title-multiple-mids":
      "User already connected",
    "body-multiple-mids":
      "This user is currently connected to a QuickBooks account and cannot be linked again. Reach out to your system administrator to manage or update the existing integration.",
    "title-mid-already-connected":
      "Store already connected",
    "body-mid-already-connected":
      "This store is currently connected to a QuickBooks account and cannot be linked again. Reach out to your system administrator to manage or update the existing integration.",
    "title-no-mid":
      "User not connected",
    "body-no-mid":
      "Access or configuration changes require the user to be linked to a merchant account (MID).",
    okay: "Okay",
  },
  fr: {
    "title-multiple-mids":
      "Utilisateur déjà connecté",
    "body-multiple-mids":
      "Cet utilisateur est actuellement connecté à un compte QuickBooks et ne peut pas être lié à nouveau. Contactez votre administrateur système pour gérer ou mettre à jour l'intégration existante.",
    "title-mid-already-connected":
      "Magasin déjà connecté",
    "body-mid-already-connected":
      "Ce magasin est actuellement connecté à un compte QuickBooks et ne peut pas être lié à nouveau. Contactez votre administrateur système pour gérer ou mettre à jour l'intégration existante.",
    "title-no-mid":
      "Utilisateur non connecté",
    "body-no-mid":
      "L'accès ou les modifications de configuration nécessitent que l'utilisateur soit lié à un compte marchand (MID).",
    okay: "D'accord",
  },
};

export default messages;
